import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-099f41f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "result-analyzes__content" }
const _hoisted_2 = { class: "result-analyzes__column" }
const _hoisted_3 = { class: "result-analyzes__plaque" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "result-analyzes__plaque-title" }, " 1. Количество зубного налета: ", -1))
const _hoisted_5 = { class: "result-analyzes__plaque-legend" }
const _hoisted_6 = { class: "result-analyzes__plaque-percentage" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "result-analyzes__plaque-text" }, "налёта", -1))
const _hoisted_8 = { class: "result-analyzes__stone" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "result-analyzes__stone-title" }, [
  /*#__PURE__*/_createTextVNode(" 2. Наличие зубного камня: "),
  /*#__PURE__*/_createElementVNode("div", { class: "question-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "question" }, [
      /*#__PURE__*/_createElementVNode("span", null, "?")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "question-text" }, " Наличие зубного камня и/или пигментированного зубного налета увеличивает риск возникновения заболеваний полости рта. ")
  ])
], -1))
const _hoisted_10 = { class: "result-analyzes__stones" }
const _hoisted_11 = { class: "result-analyzes__stones-item" }
const _hoisted_12 = { class: "result-analyzes__pigmented-plaque" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "result-analyzes__pigmented-plaque-title" }, " 3. Пигментированный зубной налет: ", -1))
const _hoisted_14 = { class: "result-analyzes__pigmented-plaque-list" }
const _hoisted_15 = { class: "result-analyzes__pigmented-plaque-item" }
const _hoisted_16 = {
  key: 0,
  class: "result-analyzes__cfe"
}
const _hoisted_17 = { class: "result-analyzes__cfe-header" }
const _hoisted_18 = { class: "result-analyzes__cfe-title" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "question" }, [
    /*#__PURE__*/_createElementVNode("span", null, "?")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "question-text" }, " Сумма показателей: кариес, пломбированные, удаленные зубы ")
], -1))
const _hoisted_20 = { class: "result-analyzes__cfe-content" }
const _hoisted_21 = {
  key: 1,
  class: "result-analyzes__pigmented-plaque"
}
const _hoisted_22 = { class: "result-analyzes__stone-title" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "question" }, [
    /*#__PURE__*/_createElementVNode("span", null, "?")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "question-text" }, " Сумма показателей: кариес, пломбированные, удаленные зубы ")
], -1))
const _hoisted_24 = { class: "result-analyzes__pigmented-plaque-list" }
const _hoisted_25 = { class: "result-analyzes__pigmented-plaque-item" }
const _hoisted_26 = { class: "result-analyzes__column" }
const _hoisted_27 = { class: "result-analyzes__indexes" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "result-analyzes__indexes-title" }, "5. Индексы гигиены:", -1))
const _hoisted_29 = { class: "result-analyzes__indexes-item" }
const _hoisted_30 = { class: "result-analyzes__indexes-value" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "result-analyzes__indexes-name text-bold" }, " Грин-Вермиллиона ", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "result-analyzes__indexes-name-description" }, [
  /*#__PURE__*/_createTextVNode(" оценивает уровень налета "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" и зубного камня ")
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "result-analyzes__indexes-detail" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Хороший : 0.0 — 1.2"),
  /*#__PURE__*/_createElementVNode("p", null, "Удовлетворительный: 1.3 — 3.0"),
  /*#__PURE__*/_createElementVNode("p", null, "Плохой: 3.0 — 6.0")
], -1))
const _hoisted_34 = { class: "result-analyzes__indexes-item" }
const _hoisted_35 = { class: "result-analyzes__indexes-value" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "result-analyzes__indexes-name text-bold" }, "API Lange", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "result-analyzes__indexes-name-description" }, [
  /*#__PURE__*/_createTextVNode(" измеряет количество зубного "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" налета в межзубных промежутках. ")
], -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "result-analyzes__indexes-detail" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Хороший: < 25%"),
  /*#__PURE__*/_createElementVNode("p", null, "Удовлетворительный: 25 — 39%"),
  /*#__PURE__*/_createElementVNode("p", null, "Неудовлетворительный: 40 — 69%"),
  /*#__PURE__*/_createElementVNode("p", null, "Плохой: 70 — 100%")
], -1))
const _hoisted_39 = { class: "result-analyzes__indexes-item" }
const _hoisted_40 = { class: "result-analyzes__indexes-value" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "result-analyzes__indexes-name text-bold" }, " Федорова-Володкиной ", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "result-analyzes__indexes-name-description" }, [
  /*#__PURE__*/_createTextVNode(" оценивает степень зубного "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" налета на зубах для детей "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" и подростков до 15 лет. ")
], -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "result-analyzes__indexes-detail" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Хороший : 1.0 — 1.5"),
  /*#__PURE__*/_createElementVNode("p", null, "Удовлетворительный: 1.6 — 2.0"),
  /*#__PURE__*/_createElementVNode("p", null, "Неудовлетворительный: 2.1 — 2.5"),
  /*#__PURE__*/_createElementVNode("p", null, "Плохой: 2.6 — 3.4"),
  /*#__PURE__*/_createElementVNode("p", null, "Очень плохой: 3.5 — 5.0")
], -1))
const _hoisted_44 = { class: "result-analyzes__indexes-item" }
const _hoisted_45 = { class: "result-analyzes__indexes-value" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "result-analyzes__indexes-name text-bold" }, "PHP", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "result-analyzes__indexes-name-description" }, " Необходим для определения эффективности навыков гигиены. ", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "result-analyzes__indexes-detail" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Отличный: 0"),
  /*#__PURE__*/_createElementVNode("p", null, "Хороший: 0.1 — 0.6"),
  /*#__PURE__*/_createElementVNode("p", null, "Удовлетворительный: 0.7 — 1.6"),
  /*#__PURE__*/_createElementVNode("p", null, "Неудовлетворительный: >1.7")
], -1))
const _hoisted_49 = { class: "result-analyzes__cfe-button" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Изменить ")

import {
  computed,
  onMounted,
  watch,
  reactive,
  PropType,
  ref,
} from 'vue'
import { useRoute } from 'vue-router'
import { ResultAnalyzesType } from '@/shared/types'
import { RESULT_STATUS } from '@/shared/constants'
import { showErrorMessage } from '@/shared/utils'
import { patientApi, reportApi } from '@/shared/api'
import { ElMessage } from 'element-plus'
import { PlaqueReportController } from '@/pages/PlaqueReportPage/plaqueReport'

interface Props {
  resultAnalyzes: ResultAnalyzesType
  plaqueReportController: PlaqueReportController
}


export default /*#__PURE__*/_defineComponent({
  props: {
    resultAnalyzes: null,
    plaqueReportController: null
  },
  setup(__props: any) {

const props = __props as {
  resultAnalyzes: ResultAnalyzesType
  plaqueReportController: PlaqueReportController
}



const route = useRoute()

const patientId = computed(() =>
  route.params.patientId !== 'null-patient'
    ? Number(route.params.patientId)
    : null
)
const reportId = computed(() => route.params.reportId)
const isPreviewMode = computed(() => route.query['view-mode'] === '1')
const age = ref(null)
const isChild = computed(() => age.value <= 15)

const initialCfeValues = reactive({
  caries: null,
  filling: null,
  extracted: null,
})
const cfeValues = reactive({
  caries: null,
  filling: null,
  extracted: null,
})

const total = computed(() => {
  if (!cfeValues.caries && !cfeValues.filling && !cfeValues.extracted) {
    return 0
  }
  if (!cfeValues.caries) {
    return cfeValues.filling + cfeValues.extracted
  }
  if (!cfeValues.filling) {
    return cfeValues.caries + cfeValues.extracted
  }
  return cfeValues.caries + cfeValues.filling + cfeValues.extracted
})

const isUpdatedCfe = computed(() => {
  return (
    cfeValues.caries !== initialCfeValues.caries ||
    cfeValues.filling !== initialCfeValues.filling ||
    cfeValues.extracted !== initialCfeValues.extracted
  )
})

const getInfoPatient = async (patientId: number | null) => {
  if (patientId === null) {
    return
  }
  const [error, response] = await patientApi.getPatientInfo(patientId)

  if (error) {
    showErrorMessage(error)
  } else {
    const date = response.data.patient.date.split('.')
    age.value = Math.floor(
      (new Date().getTime() - Number(new Date(date[2], date[1] - 1, date[0]))) /
        (24 * 3600 * 365.25 * 1000)
    )
  }
}

const updateCfeValues = async () => {
  const [error, response] = await reportApi.updateCfeValues(
    Number(reportId.value),
    cfeValues
  )
  const { caries, filling, extracted } = cfeValues

  if (error) {
    showErrorMessage(error)
  } else {
    ElMessage({
      message: 'КПУ успешно изменён',
      type: 'success',
    })

    initialCfeValues.caries = caries
    initialCfeValues.filling = filling
    initialCfeValues.extracted = extracted

    props.plaqueReportController.updateCfeValues(caries, filling, extracted)
  }
}

const setInitialValueCfe = () => {
  const reportData = props.plaqueReportController.getReportData()

  if (reportData) {
    const { caries, filling, extracted } =
      props.plaqueReportController.getCfeValues()
    initialCfeValues.caries = caries ? caries : null
    initialCfeValues.filling = filling ? filling : null
    initialCfeValues.extracted = extracted ? extracted : null

    cfeValues.caries = caries ? caries : null
    cfeValues.filling = filling ? filling : null
    cfeValues.extracted = extracted ? extracted : null
  }
}

const hygieneStatus = computed((): string | undefined => {
  const colorStatuses = {
    red: RESULT_STATUS.bad,
    yellow: RESULT_STATUS.unsatisfactory,
    green: RESULT_STATUS.good,
  }

  return colorStatuses[props.resultAnalyzes.color]
})

const hygieneStatusText = computed(() => {
  if (hygieneStatus.value === RESULT_STATUS.unsatisfactory) {
    return 'Уделите внимание гигиене'
  }

  if (hygieneStatus.value === RESULT_STATUS.good) {
    return 'Прекрасная гигиена'
  }

  return 'Необходима срочная забота'
})

watch(
  () => props.resultAnalyzes.index.cfe,
  () => {
    setInitialValueCfe()
  }
)

watch(reportId, () => {
  setInitialValueCfe()
})

onMounted(() => {
  getInfoPatient(patientId.value)
  setInitialValueCfe()
})

return (_ctx: any,_cache: any) => {
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_icon_template = _resolveComponent("icon-template")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'result-analyzes--preview': _unref(isPreviewMode) }, "result-analyzes"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", {
          class: _normalizeClass([{
            'result-analyzes__title--preview': _unref(isPreviewMode),
          }, "result-analyzes__title"])
        }, " Результаты анализа ", 2),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", {
            class: _normalizeClass([{
              'result-analyzes__plaque-status--unsatisfactory':
                _unref(hygieneStatus) === _unref(RESULT_STATUS).unsatisfactory,
              'result-analyzes__plaque-status--good':
                _unref(hygieneStatus) === _unref(RESULT_STATUS).good,
            }, "result-analyzes__plaque-status"])
          }, _toDisplayString(_unref(hygieneStatusText)), 3),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", null, _toDisplayString(Math.round(__props.resultAnalyzes.index.long)) + "% - длительный налет ", 1),
            _createElementVNode("p", null, _toDisplayString(Math.round(__props.resultAnalyzes.index.day)) + "% - суточный налет", 1)
          ]),
          _createVNode(_component_el_progress, {
            percentage: __props.resultAnalyzes.index.long + __props.resultAnalyzes.index.day,
            status: _unref(hygieneStatus),
            "stroke-width": 88,
            class: "result-analyzes__plaque-progress",
            "text-inside": ""
          }, {
            default: _withCtx(({ percentage }) => [
              _createElementVNode("p", _hoisted_6, _toDisplayString(Math.round(percentage)) + "% ", 1),
              _hoisted_7
            ]),
            _: 1
          }, 8, ["percentage", "status"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("ul", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.resultAnalyzes.stoneList, (stone) => {
              return (_openBlock(), _createElementBlock("li", _hoisted_11, _toDisplayString(stone), 1))
            }), 256))
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("ul", _hoisted_14, [
            _createElementVNode("li", _hoisted_15, _toDisplayString(__props.resultAnalyzes.isPigmented ? 'Есть' : 'Отсутствует'), 1)
          ])
        ]),
        (!_unref(isPreviewMode))
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("h3", _hoisted_18, "4. КПУ: " + _toDisplayString(_unref(total)), 1),
                _hoisted_19
              ]),
              _createElementVNode("div", _hoisted_20, [
                _withDirectives(_createElementVNode("input", {
                  ref: "caries_navigation",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(cfeValues).caries) = $event)),
                  type: "number",
                  class: "result-analyzes__cfe-input",
                  maxlength: "2",
                  onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (this.$refs['filling_navigation'].focus()), ["enter"]))
                }, null, 544), [
                  [_vModelText, _unref(cfeValues).caries]
                ]),
                _withDirectives(_createElementVNode("input", {
                  ref: "filling_navigation",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(cfeValues).filling) = $event)),
                  type: "number",
                  class: "result-analyzes__cfe-input",
                  maxlength: "2",
                  onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (this.$refs['extracted_navigation'].focus()), ["enter"]))
                }, null, 544), [
                  [_vModelText, _unref(cfeValues).filling]
                ]),
                _withDirectives(_createElementVNode("input", {
                  ref: "extracted_navigation",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(cfeValues).extracted) = $event)),
                  type: "number",
                  class: "result-analyzes__cfe-input",
                  maxlength: "2"
                }, null, 512), [
                  [_vModelText, _unref(cfeValues).extracted]
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createTextVNode(" 4. КПУ: " + _toDisplayString(_unref(cfeValues).caries + _unref(cfeValues).filling + _unref(cfeValues).extracted) + " ", 1),
                _hoisted_23
              ]),
              _createElementVNode("ul", _hoisted_24, [
                _createElementVNode("li", _hoisted_25, " К = " + _toDisplayString(_unref(cfeValues).caries !== null ? _unref(cfeValues).caries : '-') + " | П = " + _toDisplayString(_unref(cfeValues).filling !== null ? _unref(cfeValues).filling : '-') + " | У = " + _toDisplayString(_unref(cfeValues).extracted !== null ? _unref(cfeValues).extracted : '-'), 1)
              ])
            ]))
      ]),
      _createVNode(_component_el_divider, {
        class: "result-analyzes__divider",
        direction: "vertical"
      }),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createVNode(_component_el_row, { class: "result-analyzes__indexes-row" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("p", _hoisted_30, _toDisplayString(__props.resultAnalyzes.index.greenVermillion.toFixed(1)), 1),
                    _createVNode(_component_icon_template, {
                      class: _normalizeClass([{
                    'result-analyzes__indexes-status--success':
                      __props.resultAnalyzes.index.greenVermillion < 1.3,
                    'result-analyzes__indexes-status--danger':
                      __props.resultAnalyzes.index.greenVermillion > 3.0,
                  }, "result-analyzes__indexes-status"]),
                      height: "12",
                      name: "index-status",
                      width: "12"
                    }, null, 8, ["class"])
                  ]),
                  _hoisted_31,
                  _hoisted_32,
                  _hoisted_33
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("p", _hoisted_35, _toDisplayString(__props.resultAnalyzes.index.apiLange.toFixed(1)) + "% ", 1),
                    _createVNode(_component_icon_template, {
                      class: _normalizeClass([{
                    'result-analyzes__indexes-status--success':
                      __props.resultAnalyzes.index.apiLange < 25,
                    'result-analyzes__indexes-status--danger':
                      __props.resultAnalyzes.index.apiLange > 39,
                  }, "result-analyzes__indexes-status"]),
                      height: "12",
                      name: "index-status",
                      width: "12"
                    }, null, 8, ["class"])
                  ]),
                  _hoisted_36,
                  _hoisted_37,
                  _hoisted_38
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              (_unref(isChild))
                ? (_openBlock(), _createBlock(_component_el_col, {
                    key: 0,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("p", _hoisted_40, _toDisplayString(__props.resultAnalyzes.index.fedorovVolodkina.toFixed(1)), 1),
                        _createVNode(_component_icon_template, {
                          class: _normalizeClass([{
                    'result-analyzes__indexes-status--success':
                      __props.resultAnalyzes.index.fedorovVolodkina < 1.6,
                    'result-analyzes__indexes-status--danger':
                      __props.resultAnalyzes.index.fedorovVolodkina > 2.0,
                  }, "result-analyzes__indexes-status"]),
                          height: "12",
                          name: "index-status",
                          width: "12"
                        }, null, 8, ["class"])
                      ]),
                      _hoisted_41,
                      _hoisted_42,
                      _hoisted_43
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_unref(isChild))
                ? (_openBlock(), _createBlock(_component_el_col, {
                    key: 1,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("p", _hoisted_45, _toDisplayString(__props.resultAnalyzes.index.php.toFixed(1)), 1),
                        _createVNode(_component_icon_template, {
                          class: _normalizeClass([{
                    'result-analyzes__indexes-status--success':
                      __props.resultAnalyzes.index.php < 0.7,
                    'result-analyzes__indexes-status--danger':
                      __props.resultAnalyzes.index.php > 1.6,
                  }, "result-analyzes__indexes-status"]),
                          height: "12",
                          name: "index-status",
                          width: "12"
                        }, null, 8, ["class"])
                      ]),
                      _hoisted_46,
                      _hoisted_47,
                      _hoisted_48
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_49, [
      (!_unref(isPreviewMode))
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: updateCfeValues,
            type: "primary",
            round: "",
            disabled: !_unref(isUpdatedCfe)
          }, {
            default: _withCtx(() => [
              _hoisted_50
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})